import { useEffect, useState } from 'react'
import { SquareButton2 } from '../atoms';
import styled from 'styled-components';

type ButtonInfoProps = {
  icon: string
  text: string
}

type SquareButtonsCardProps = {
  onSelected: (isSelected: number | null) => void
  buttons: ButtonInfoProps[]
  defaultSelected?: number | null
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-items: center;
  gap: 3rem;
`

export const SquareButtonsCard = ({ onSelected, buttons, defaultSelected }: SquareButtonsCardProps) => {
  const [isSelected, setIsSelected] = useState<number | null>(defaultSelected ?? null)

  useEffect(() => {
    onSelected(isSelected)
  }, [isSelected])

  return (
    <Wrapper>
      {buttons.map((btn, index) => (
        <SquareButton2
          key={index}
          action={() => {
            setIsSelected(index)
          }}
          selected={isSelected === index}
        >
          <>
            <img src={btn.icon} alt={btn.text} width={48} height={48}/>
            <span>{btn.text}</span>
          </>
        </SquareButton2>
      ))}
    </Wrapper>
  );
};
